import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { listRankingOverrides } from "../../api/clientVendorDirectoryRankingApi";
import ClientVendorDirectorySubnav from "../../components/casamap/admin/ClientVendorDirectorySubnav";
import ClientVendorDirectoryRankingSubnav from "../../components/casamap/admin/ClientVendorDirectoryRankingSubnav";
import { ClientPortalError, ClientPortalLoading } from "../../components/clientPortal/ClientPortalStates";
import { formatClientDate, formatStatusLabel } from "../../utils/clientPortalFormat";
import { useLocale } from "../../intl";
import "../../styles/casamapaVendorDirectoryAdmin.css";

const COPY_PREFIX = "realEstate.casaMapa.admin.vendorDirectoryWorkspace.ranking.overrides";

export default function ClientVendorDirectoryRankingOverrideListPage() {
  const { clientViewId } = useParams();
  const { t, locale } = useLocale();
  const [overrides, setOverrides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const body = await listRankingOverrides(clientViewId);
      setOverrides(body.overrides || []);
    } catch (error) {
      setErrorMessage(error.message || t(`${COPY_PREFIX}.loadError`));
    } finally {
      setLoading(false);
    }
  }, [clientViewId, t]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="page-content cvd-admin">
      <ClientVendorDirectorySubnav clientViewId={clientViewId} />
      <ClientVendorDirectoryRankingSubnav clientViewId={clientViewId} />
      <h1 className="cvd-admin__title">{t(`${COPY_PREFIX}.title`)}</h1>
      {loading ? <ClientPortalLoading message={t(`${COPY_PREFIX}.loading`)} /> : null}
      {errorMessage ? <ClientPortalError message={errorMessage} onRetry={load} /> : null}
      {!loading && !errorMessage ? (
        <div className="cvd-table-wrap">
          <table className="cvd-table">
            <thead>
              <tr>
                <th>{t(`${COPY_PREFIX}.table.vendor`)}</th>
                <th>{t(`${COPY_PREFIX}.table.type`)}</th>
                <th>{t(`${COPY_PREFIX}.table.reason`)}</th>
                <th>{t(`${COPY_PREFIX}.table.starts`)}</th>
                <th>{t(`${COPY_PREFIX}.table.ends`)}</th>
                <th>{t(`${COPY_PREFIX}.table.status`)}</th>
              </tr>
            </thead>
            <tbody>
              {overrides.map((item) => (
                <tr key={item.id}>
                  <td>{item.vendor_name || item.vendor_id}</td>
                  <td>{formatStatusLabel(item.override_type)}</td>
                  <td>{item.reason}</td>
                  <td>{formatClientDate(item.starts_at, locale)}</td>
                  <td>{item.ends_at ? formatClientDate(item.ends_at, locale) : "—"}</td>
                  <td>{item.revoked_at ? t(`${COPY_PREFIX}.revoked`) : t(`${COPY_PREFIX}.active`)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
